import { AdminPartnerPrice } from '@returnmates/client-core/src/graphql/generated/api'
import { memo, useCallback } from 'react'
import { useField } from 'react-final-form'

import useStyles from '../styles'
import Price from './Price'

function PricesSettings() {
  const classes = useStyles({})
  const { input: prices } = useField<Array<AdminPartnerPrice>>('priceHubs')

  const addPrice = useCallback(() => {
    if (prices.value.every(p => p.hubId)) {
      prices.onChange([...prices.value, {}])
    }
  }, [prices])

  const onHubChange = useCallback(
    (val, hubId) => {
      const newPrices = prices.value.map(p => (p.hubId === hubId ? { ...p, hubId: val } : p))

      prices.onChange(newPrices)
    },
    [prices],
  )

  const onPriceChange = useCallback(
    (val, hubId) => {
      const newPrices = prices.value.map(p => (p.hubId === hubId ? { ...p, price: +val } : p))

      prices.onChange(newPrices)
    },
    [prices],
  )

  const removePrice = useCallback(
    hubId => {
      const newPrices = prices.value.filter(p => p.hubId !== hubId)

      prices.onChange(newPrices)
    },
    [prices],
  )

  return (
    <>
      {prices.value.map(p => (
        <Price
          price={p.price}
          hubId={p.hubId}
          code={p.partnerCode}
          key={`${p.hubId}-${p.partnerCode}`}
          onHubChange={onHubChange}
          onPriceChange={onPriceChange}
          removePrice={removePrice}
        />
      ))}
      <div className={classes.addPrice} onClick={addPrice}>
        + add price
      </div>
    </>
  )
}

export default memo(PricesSettings)
